import {LogAtributVO, LogDokumentVO, LogVO} from '../../api';

import {ModalComponentProps, Block, Button, Card, Col, Dialog, DialogBody, DialogFooter, List, ListItem, Row} from '@mc/ui-v4';

import React from 'react';
import {formatDate} from '../../helpers/Formatter';
import {DocumentChangeItem} from './document/DocumentChangeItem';
import {ACCESSIBILITY_ITEMS, looksLikeAccessibilityValue, parseAccessibilityValue} from '../../assets/accessibility/accessibilityCodelist';
import './AttributesChangeModal.scss';

type Props = ModalComponentProps & {
    title: string;
    featureId: string;
    logAtts?: LogAtributVO[];
    logDocs?: LogDokumentVO[];
    datalog: LogVO;
};

/**
 * Hodnota atributu přístupnosti v logu změn – stejně jako v detailu objektu a v atributové tabulce
 * vykreslíme všechny ikony přístupnosti a ty, které hodnota neobsahuje, zobrazíme zašedle.
 * Popisek značky je v `title` (tooltip po najetí myší).
 */
const AccessibilityLogValue: React.FC<{value?: string}> = ({value}) => {
    const activeCodes = parseAccessibilityValue(value);
    return (
        <div className="accessibility-log">
            {ACCESSIBILITY_ITEMS.map(item => {
                const inactive = !activeCodes.includes(item.kod);
                return (
                    <img
                        key={item.kod}
                        src={item.icon}
                        alt={item.nazev}
                        title={item.nazev}
                        className={`accessibility-log__icon${inactive ? ' accessibility-log__icon--inactive' : ''}`}
                    />
                );
            })}
        </div>
    );
};

export const AttributesChangeModal: React.FC<Props> = ({onClose, featureId, logAtts, logDocs, title, datalog}) => {
    return (
        <Dialog isOpen onClose={onClose} title={title} size="md">
            <DialogBody>
                <Card mode={'view'} style={{background: '#ecf1f9'}}>
                    <Row>
                        <Col>
                            <Block title="Datum">{formatDate(datalog.datum)}</Block>
                        </Col>
                        <Col>
                            <Block title="Pracovník">{datalog.nazevPracovnika}</Block>
                        </Col>
                        <Col>
                            <Block title="Akce">{datalog.nazevAkce ?? 'Editace'}</Block>
                        </Col>
                    </Row>
                </Card>
                <Card mode={'view'} style={{background: '#ecf1f9'}} className="my-2 p-1">
                    <List mode={'labels'}>
                        <ListItem>
                            <Row>
                                <Col>Atribut</Col>
                                <Col>Před</Col>
                                <Col>Po</Col>
                            </Row>
                        </ListItem>
                    </List>
                    <List mode={'input'} compact>
                        {logAtts?.map(att => {
                            // Log nenese typ atributu, hodnotu přístupnosti proto poznáme z jejího obsahu.
                            const accessibility = looksLikeAccessibilityValue(att.hodnotaPred, att.hodnotaPo);
                            return (
                                <ListItem key={`a_${att.id}`}>
                                    <Row>
                                        <Col>{att.nazevAtribut}</Col>
                                        <Col>{accessibility ? <AccessibilityLogValue value={att.hodnotaPred} /> : (att.hodnotaPred ?? 'Nevyplněno')}</Col>
                                        <Col>{accessibility ? <AccessibilityLogValue value={att.hodnotaPo} /> : (att.hodnotaPo ?? 'Nevyplněno')}</Col>
                                    </Row>
                                </ListItem>
                            );
                        })}
                        {logDocs?.map(doc => <DocumentChangeItem key={`d_${doc.id}`} featureId={featureId} log={doc} />)}
                    </List>
                </Card>
            </DialogBody>
            <DialogFooter>
                <Button onClick={onClose}>Zavřít</Button>
            </DialogFooter>
        </Dialog>
    );
};
